import React from 'react';
import { MapPin, Phone, Mail, Clock, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function ContactPage() {
  return <div className="bg-white min-h-screen" data-id="element-234">
      <div className="bg-blue-900 text-white py-16" data-id="element-235">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-236">
          <h1 className="text-4xl font-bold mb-4" data-id="element-237">Kontakt</h1>
          <p className="text-xl text-blue-200" data-id="element-238">
            Wir sind für Sie da. Kontaktieren Sie uns für ein unverbindliches
            Angebot.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-239">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-240">
          {/* Contact Info */}
          <div data-id="element-241">
            <h2 className="text-2xl font-bold text-gray-900 mb-8" data-id="element-242">
              Unsere Kontaktdaten
            </h2>

            <div className="space-y-8" data-id="element-243">
              <div className="flex items-start" data-id="element-244">
                <div className="bg-blue-100 p-3 rounded-lg mr-4" data-id="element-245">
                  <MapPin className="w-6 h-6 text-blue-800" data-id="element-246" />
                </div>
                <div data-id="element-247">
                  <h3 className="font-bold text-gray-900 mb-1" data-id="element-248">Anschrift</h3>
                  <p className="text-gray-600" data-id="element-249">
                    Lissowski Glas- und Gebäudereinigung GmbH
                    <br data-id="element-250" />
                    Jülicher Straße 126
                    <br data-id="element-251" />
                    52070 Aachen
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-252">
                <div className="bg-blue-100 p-3 rounded-lg mr-4" data-id="element-253">
                  <Phone className="w-6 h-6 text-blue-800" data-id="element-254" />
                </div>
                <div data-id="element-255">
                  <h3 className="font-bold text-gray-900 mb-1" data-id="element-256">Telefon</h3>
                  <p className="text-gray-600 mb-1" data-id="element-257">Rufen Sie uns an:</p>
                  <a href="tel:0241512746" className="text-xl font-bold text-blue-700 hover:text-blue-900" data-id="element-258">
                    0241 512746
                  </a>
                </div>
              </div>

              <div className="flex items-start" data-id="element-259">
                <div className="bg-blue-100 p-3 rounded-lg mr-4" data-id="element-260">
                  <Mail className="w-6 h-6 text-blue-800" data-id="element-261" />
                </div>
                <div data-id="element-262">
                  <h3 className="font-bold text-gray-900 mb-1" data-id="element-263">E-Mail</h3>
                  <a href="mailto:buero@lissowski-gmbh.de" className="text-blue-700 hover:text-blue-900 font-medium" data-id="element-264">
                    buero@lissowski-gmbh.de
                  </a>
                </div>
              </div>

              <div className="flex items-start" data-id="element-265">
                <div className="bg-blue-100 p-3 rounded-lg mr-4" data-id="element-266">
                  <Clock className="w-6 h-6 text-blue-800" data-id="element-267" />
                </div>
                <div data-id="element-268">
                  <h3 className="font-bold text-gray-900 mb-1" data-id="element-269">Bürozeiten</h3>
                  <p className="text-gray-600" data-id="element-270">
                    Montag - Donnerstag: 8:00 - 14:00 Uhr
                  </p>
                  <p className="text-gray-600" data-id="element-271">Freitag: 8:00 - 12:00 Uhr</p>
                </div>
              </div>

              <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 flex items-start" data-id="element-272">
                <AlertCircle className="w-6 h-6 text-amber-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-273" />
                <div data-id="element-274">
                  <h4 className="font-bold text-amber-800 mb-1" data-id="element-275">
                    24-Stunden-Service
                  </h4>
                  <p className="text-sm text-amber-700" data-id="element-276">
                    In Not- und Ausnahmefällen sind wir rund um die Uhr für Sie
                    erreichbar.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-gray-50 p-8 rounded-2xl border border-gray-200" data-id="element-277">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-278">
              Nachricht senden
            </h2>
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-279">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-280">
                <div data-id="element-281">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-282">
                    Name *
                  </label>
                  <input type="text" id="name" className="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-3 border" placeholder="Ihr Name" required data-id="element-283" />
                </div>
                <div data-id="element-284">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-285">
                    E-Mail *
                  </label>
                  <input type="email" id="email" className="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-3 border" placeholder="ihre@email.de" required data-id="element-286" />
                </div>
              </div>

              <div data-id="element-287">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-288">
                  Telefon
                </label>
                <input type="tel" id="phone" className="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-3 border" placeholder="Ihre Telefonnummer" data-id="element-289" />
              </div>

              <div data-id="element-290">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-291">
                  Nachricht *
                </label>
                <textarea id="message" rows={4} className="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-3 border" placeholder="Wie können wir Ihnen helfen?" required data-id="element-292"></textarea>
              </div>

              <div className="flex items-start" data-id="element-293">
                <input id="privacy" type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded mt-1" required data-id="element-294" />
                <label htmlFor="privacy" className="ml-2 block text-sm text-gray-600" data-id="element-295">
                  Ich stimme zu, dass meine Angaben zur Kontaktaufnahme und
                  Zuordnung für eventuelle Rückfragen dauerhaft gespeichert
                  werden.
                </label>
              </div>

              <Button type="submit" fullWidth data-id="element-296">
                Nachricht absenden
              </Button>
            </form>
          </div>
        </div>

        {/* Map Placeholder */}
        <div className="mt-16 rounded-2xl overflow-hidden shadow-lg border border-gray-200 h-[400px] bg-gray-100 relative flex items-center justify-center" data-id="element-297">
          <div className="text-center" data-id="element-298">
            <MapPin className="w-12 h-12 text-gray-400 mx-auto mb-4" data-id="element-299" />
            <p className="text-gray-500 font-medium" data-id="element-300">
              Hier würde die Google Maps Karte geladen werden
            </p>
            <p className="text-gray-400 text-sm" data-id="element-301">
              Jülicher Straße 126, 52070 Aachen
            </p>
          </div>
        </div>
      </div>
    </div>;
}